import moment from "moment";
import SampleCollection from "@/collections/lab/SampleCollection";
import {
  SCHEDULE_FORM_RESET,
  SELECTED_DATE_SET,
  SCHEDULE_FORM_UPDATE,
  SCHEDULE_SAMPLE_LIST_UPDATE,
} from "@/store/mutation-types";

const state = {
  selected_date: moment().format("YYYY-MM-DD"),
  schedule_form: {
    sample_type_id: null,
    processes: null,
    process_type: null,
    samples: new SampleCollection(),
  },
  schedule_sample_list: [],
};

const setDefaultState = () => {
  return {
    sample_type_id: null,
    processes: null,
    process_type: null,
    samples: new SampleCollection(),
  };
};

const getters = {
  selectedDate: (state) => state.selected_date,
  scheduleForm: (state) => state.schedule_form,
  scheduleSampleList: (state) => state.schedule_sample_list,
};

const mutations = {
  SCHEDULE_FORM_RESET: (state) => {
    state.schedule_form = setDefaultState();
  },
  SELECTED_DATE_SET: (state, date) => {
    state.selected_date = date;
  },
  SCHEDULE_FORM_UPDATE: (state, { field, value }) => {
    switch (field) {
      case "sample_type_id":
        state.schedule_form.process_type = null;
        state.schedule_form.processes = null;
        break;
      case "process_type":
        state.schedule_form.processes = [];
        break;
      default:
    }
    state.schedule_form = {
      ...state.schedule_form,
      [field]: value,
    };
  },
  SCHEDULE_SAMPLE_LIST_UPDATE: (state, update) => {
    state.schedule_sample_list = update;
  },
};

const actions = {
  RESET_SCHEDULE_FORM: ({ commit }) => {
    commit(SCHEDULE_FORM_RESET);
  },
  SET_SELECTED_DATE: ({ commit }, data) => {
    commit(SELECTED_DATE_SET, data);
  },
  UPDATE_SCHEDULE_FORM: ({ commit }, data) => {
    commit(SCHEDULE_FORM_UPDATE, data);
  },
  UPDATE_SCHEDULE_SAMPLE_LIST: ({ commit }, data) => {
    commit(SCHEDULE_SAMPLE_LIST_UPDATE, data);
  },
};

export default {
  getters,
  mutations,
  actions,
  state,
};
